// Grayscale Constants
export const WHITE: string = '#FFFFFF';
export const BLACK: string = '#000000';
export const DARK_GRAY: string = '#7A7A7A';
export const GRAY: string = '#ADADAD';
export const LIGHT_GRAY: string = '#D7D7D7';

// Color Constants
export const RED: string = '#ED3233';
export const YELLOW: string = '#FDDA35';
export const GREEN: string = '#25BA6F';
export const BLUE: string = '#0361AA';
export const PURPLE: string = '890C58';

// Palette
export const PALETTE_GREEN: string = "#599341";
export const PALETTE_WHITE: string = "#f9f9fb";
export const PALETTE_DARK_WHITE: string = "#f6f6f9";
export const PALETTE_LIGHT_BLUE: string = "#90caf9";
export const PALETTE_DARK_BLUE: string = "#011e33";
export const PALETTE_LIGHT_GREY: string = "#b7b4ae";
export const PALETTE_GREY: string = "#363430";
export const PALETTE_DARK_GREY: string = "#2b2926";
export const PALETTE_BLACK: string = "#171614";
export const PALETTE_ORANGE: string = "#FAD56E";
export const PALETTE_RED: string = "#FA6861";
export const PALETTE_PINK: string = "#FF2B79";
export const PALETTE_PURPLE: string = "#8689FD";
export const PALETTE_BLUE: string = "#86FDF3";
export const PALETTE_YELLOW: string = "#FFA121";

// Game
export const GAME_BOX_DEFAULT_COLOR: string = "#363c4f";
export const GAME_BOX_MATCH_COLOR: string = "#32821f";
export const GAME_BOX_POSITION_COLOR: string = "#b7b400";

// Font Weights
export const FONT_WEIGHT_REGULAR: number = 400;
export const FONT_WEIGHT_MEDIUM: number = 500;
export const FONT_WEIGHT_SEMI_BOLD: number = 600;
export const FONT_WEIGHT_BOLD: number = 700;
export const FONT_WEIGHT_EXTRA_BOLD: number = 800;

export const FONT_FAMILY: string = 'Chakra Petch,sans-serif';